module.exports = __webpack_public_path__ + "img/logo1.d16a951f.png";